<div fxLayout="row" class="dialog-title-check-box" fxLayoutGap="10px">
  <h3 mat-dialog-title>{{ 'addText.title' | translate }}</h3>
</div>

<div class="form-container" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
  <mat-form-field fxFlex>
    <mat-label>{{ 'addText.text' | translate }}</mat-label>
    <input matInput maxlength="100" [formControl]="textControl">
  </mat-form-field>
</div>

<div class="actions" fxLayout="row" mat-dialog-actions>
  <button mat-button mat-dialog-close color="primary">{{ 'addText.cancel' | translate }}</button>
  <button mat-raised-button [disabled]="textControl.invalid" color="primary" (click)="add()">
    {{ 'addText.add' | translate }}
  </button>
</div>
